<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">
    <span class="primary hover" (click)="onBack()">Export {{ exportChannel?.label }} templates</span>
    <i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
    {{ isNew ? 'New template' : 'Template details' }}
  </div>
</div>

@if (exportTemplate?.isDefault) {
  <div class="padding bg-orange flex center">
    <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
    <span>
      This is a
      <b>default template</b>
      . Edit will affect many products.
    </span>
  </div>
}

<div class="padding-large m-padding">
  <div class="page-layout">
    <bt-page-header
      title="Export {{ exportChannel?.label }} template details"
      subtitle="Product conditions and image formats of the export template"
      icon="fa fa-arrow-right-from-bracket"
    >
      <button (click)="saveExportTemplate()">
        <i class="fa-solid fa-save"></i>
        Save Changes
      </button>
    </bt-page-header>
    @if (exportTemplate) {
      <div class="flex margin-top-large">
        <div class="flex-1 flex column">
          <b class="flex center padding-top-small padding-bottom-small">Product conditions :</b>
          <div class="border padding dashed">
            <div class="flex column">
              Brand:

              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (exportTemplate?.brand) {
                    <b class="primary">{{ exportTemplate.brand.name }}</b>
                  } @else {
                    <span class="grey">All brands</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openBrandFilterModal()"
                  [disabled]="exportTemplate?.isDefault"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top  {{ !canSelectCollectionAndCategory() ? 'disabled' : '' }}">
              Collection:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (exportTemplate?.collection) {
                    <b class="primary">{{ exportTemplate.collection.name }}</b>
                  } @else {
                    <span class="grey">All collections</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openCollectionFilterModal()"
                  [disabled]="!canSelectCollectionAndCategory()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top  {{ !canSelectCollectionAndCategory() ? 'disabled' : '' }}">
              Category:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (exportTemplate?.category) {
                    <b class="primary">{{ exportTemplate.category.name }}</b>
                  } @else {
                    <span class="grey">All categories</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openCategoryFilterModal()"
                  [disabled]="!canSelectCollectionAndCategory()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top  {{ !canSelectCollectionAndCategory() ? 'disabled' : '' }}">
              Gender:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (exportTemplate?.gender) {
                    <b class="primary">{{ exportTemplate.gender.name }}</b>
                  } @else {
                    <span class="grey">All genders</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openGenderFilterModal()"
                  [disabled]="!canSelectCollectionAndCategory()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top {{ !canSelectGenderStyleGroupAndStyle() ? 'disabled' : '' }}">
              Style group:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (exportTemplate?.styleGroup) {
                    <b class="primary">{{ exportTemplate.styleGroup.name }}</b>
                  } @else {
                    <span class="grey">All style groups</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openStyleGroupFilterModal()"
                  [disabled]="!canSelectGenderStyleGroupAndStyle()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top {{ !canSelectGenderStyleGroupAndStyle() ? 'disabled' : '' }}">
              Styles:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @for (item of exportTemplate?.styles; track $index) {
                    <b class="primary">{{ item.code }}</b>
                    @if ($index < exportTemplate.styles.length - 1) {
                      ,
                    }
                  } @empty {
                    <span class="grey">All styles</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openStylesFilterModal()"
                  [disabled]="!canSelectGenderStyleGroupAndStyle()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top {{ !canSelectColors() ? 'disabled' : '' }}">
              Colors:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @for (item of colors; track $index) {
                    <b class="primary">{{ item.name }}</b>
                    @if ($index < colors.length - 1) {
                      ,
                    }
                  } @empty {
                    <span class="grey">All colors</span>
                  }
                </div>
                <button class="radius-left-none" (click)="openColorsFilterModal()" [disabled]="!canSelectColors()">
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-0 padding">
          <i class="fa-solid fa-arrow-right big primary margin-top-large"></i>
        </div>
        <div class="flex-4 flex column">
          <b class="flex center padding-top-small padding-bottom-small">Codes grid:</b>

          <div cdkDropListGroup class="bg-lightest-blue padding radius">
            <div class="border dashed radius bg-white padding margin-bottom">
              <!-- Shot Type row -->
              <div class="margin-bottom-small">
                <span class="grey small">Shot type</span>
                <div class="flex wrap gap-small margin-top-smallest">
                  @for (st of allShotTypes; track st.id) {
                    <button
                      class="{{ pickedShotType?.id === st.id ? 'bg-primary white' : 'stroked' }} small"
                      (click)="selectShotType(st)"
                    >
                      {{ st.code || st.name }}
                    </button>
                  }
                </div>
              </div>

              <!-- Aspect Ratio row -->
              <div class="margin-bottom-small">
                <span class="grey small">Aspect ratio</span>
                <div class="flex wrap gap-small margin-top-smallest">
                  @for (ar of allAspectRatios; track ar.id) {
                    <button
                      class="{{ pickedAspectRatio?.id === ar.id ? 'bg-primary white' : 'stroked' }} small"
                      [class.disabled]="isAspectRatioDisabled(ar)"
                      [disabled]="isAspectRatioDisabled(ar)"
                      [class.pim-builder-opt--active]="pickedAspectRatio?.id === ar.id"
                      (click)="selectAspectRatio(ar)"
                    >
                      {{ ar.label }}
                    </button>
                  }
                </div>
              </div>

              <!-- Media Format row -->
              <div class="margin-bottom-small">
                <span class="grey small">Media format</span>
                <div class="flex wrap gap-small margin-top-smallest">
                  @for (mf of allMediaFormats; track mf.id) {
                    <button
                      class="  small {{ pickedMediaFormat?.id === mf.id ? 'bg-primary white' : 'stroked' }}"
                      [class.disabled]="isMediaFormatDisabled(mf)"
                      [disabled]="isMediaFormatDisabled(mf)"
                      (click)="selectMediaFormat(mf)"
                    >
                      {{ mf.code }}
                    </button>
                  }
                </div>
              </div>

              <!-- Builder result drop zone -->

              <div class="grey small margin-top margin-bottom-small">Result chip</div>
              <div class="max-width border dashed radius padding-smallest">
                <div
                  cdkDropList
                  [cdkDropListData]="builderChip"
                  [cdkDropListEnterPredicate]="canEnterCell"
                  (cdkDropListDropped)="drop($event)"
                >
                  @if (builderChipShot) {
                    <div class="flex padding-smallest radius primary small bg-primary white hover chip" cdkDrag>
                      {{ builderChipShot.shotType?.name }},{{ builderChipShot.aspectRatio?.label }}
                      <br />
                      {{ builderChipShot.mediaFormat?.code }}
                    </div>
                    @if (isCombinationPlaced()) {
                      <span class="grey small margin-left-small">
                        <i class="fa-solid fa-circle-exclamation margin-right-smallest"></i>
                        Already placed
                      </span>
                    }
                  } @else {
                    <span class="grey small">Select all options above</span>
                  }
                </div>
              </div>
            </div>
            <!-- ── End Chip Builder ──────────────────────────────────────── -->

            <!-- Grid cells -->
            <div class="codified-use-grid">
              @for (cell of codifiedUseCells; track cell.code) {
                <div
                  class="flex column border dashed radius padding-smallest"
                  [class.bg-white]="!cell.disabled"
                  [class.bg-light-grey]="cell.disabled"
                  [class.disabled]="cell.disabled"
                  cdkDropList
                  [cdkDropListData]="cell.items"
                  [cdkDropListDisabled]="!!cell.disabled"
                  [cdkDropListEnterPredicate]="canEnterCell"
                  (cdkDropListDropped)="drop($event)"
                >
                  <span class="grey small padding-smallest">
                    {{
                      codeToNumber(cell.code) < 10
                        ? '0' + codeToNumber(cell.code)
                        : codeToNumber(cell.code) < 100
                          ? '' + codeToNumber(cell.code)
                          : codeToNumber(cell.code)
                    }}
                  </span>
                  @for (shot of cell.items; track shot.id) {
                    <div
                      class="flex-1 chip radius small hover bg-primary justify-center white radius flex center padding-smallest"
                      cdkDrag
                      [cdkDragDisabled]="!!cell.disabled"
                    >
                      {{ shot.shotType?.name }}
                      <br />
                      {{ shot.aspectRatio?.label }},{{ shot.mediaFormat?.code }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (loading) {
    <bt-loader></bt-loader>
  }
</div>
